import { ListFilter } from 'lucide-react'
import { type HTMLAttributes, useState } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'

import { Button } from '@/modules/shared/components/ui/button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@/modules/shared/components/ui/dialog'
import {
	Form,
	FormControl,
	FormField,
	FormItem,
} from '@/modules/shared/components/ui/form'
import { Search } from '@/modules/shared/components/ui/search'
import type { PayloadSearch } from '@/modules/shared/types/payload-search.type'

import { CLIENT_SEARCH_PARAMETERS } from '../constants/client-search-input.constants'
import { useCustomerSearchInputStore } from '../stores/client-search-input.store'
import { Label } from './ui/label'
import { RadioGroup, RadioGroupItem } from './ui/radio-group'
type FormSearchInputComponentProps = HTMLAttributes<HTMLInputElement> & {
	onSubmitRequest: ({ payload }: PayloadSearch) => void
	disabled?: boolean
	defaultInputValue?: string
}

export function CustomerSearchInputComponent({
	onSubmitRequest,
	defaultInputValue,
	...rest
}: FormSearchInputComponentProps) {
	const [isOpen, setIsOpen] = useState(false)
	const onClose = () => setIsOpen(false)

	const form = useForm({
		values: {
			inputValue: defaultInputValue,
		},
	})

	const {
		defaultFilter,
		actions: { setDefaultFilter },
	} = useCustomerSearchInputStore()
	const handleSubmitRequest = (data: {
		inputValue: string
		inputValueDate: string
	}) => {

		const payload = {
			inputValue: data.inputValue,
			filter: defaultFilter,
		}

		onSubmitRequest({ payload })
	}

	const handleChangeFilter = (filter: string) => {
		form.setValue('inputValue', '')
		setDefaultFilter(filter)
		onClose()
	}

	return (
		<div className="flex gap-2 flex-1">
			<Button onClick={() => setIsOpen(true)} variant="secondary" className='h-12 w-12 p-0'>
				<ListFilter size={20} />
			</Button>
			<Form {...form}>
				<form
					onSubmit={form.handleSubmit(handleSubmitRequest)}
					className="flex-1 md:flex-none md:w-96"
				>
					<FormField
						control={form.control}
						name="inputValue"
						render={({ field }) => (
							<FormItem className="flex flex-1 w-full">
								<FormControl>
									<Search
										{...field}
										onChange={(e) => {
											if (e.target.value.includes('&')) {
												if (e.target.value.includes(' &')) {
													field.onChange(e)
												} else {
													e.target.value = e.target.value.replace('&', '')
												}
											}

											field.onChange(e)
										}}
										min={3}
										onClick={(e) => {
											const inputElement = e.target as HTMLInputElement
											inputElement.select()
										}}
										value={field.value}
										onClickSearchIcon={form.handleSubmit(handleSubmitRequest)}
										placeholder={`Buscar por ${CLIENT_SEARCH_PARAMETERS.find((value) => value.parameter === defaultFilter).text}`}
										{...rest}
									/>
								</FormControl>
							</FormItem>
						)}
					/>
				</form>
			</Form>

			<Dialog open={isOpen} onOpenChange={onClose}>
				<DialogContent>
					<DialogHeader>
						<DialogTitle>Filtros</DialogTitle>
					</DialogHeader>
					<RadioGroup value={defaultFilter} className="space-y-3">
						{CLIENT_SEARCH_PARAMETERS.map((item) => (
							<div key={item.id} className="flex items-center space-x-2">
								<RadioGroupItem
									onClick={() => handleChangeFilter(item.parameter)}
									key={item.id}
									id={item.id.toString()}
									value={item.parameter}
								/>
								<Label htmlFor={item.id.toString()} className="text-md">
									{item.text}
								</Label>
							</div>
						))}
					</RadioGroup>
				</DialogContent>
			</Dialog>
		</div>
	)
}
